import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AbstractControl, Validators, FormGroup, FormBuilder, ValidatorFn, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamService } from '../services/team.service';
import { DeleteDialogComponent } from 'src/app/shared/delete-dialog.component';
import { PitchUpdateDialogComponent } from 'src/app/team-edit/pitch/pitch-update-dialog/pitch-update-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Flag, PitchList, ServiceTie, LineTeam, TeamVariant} from 'src/app/shared/models/type-list';
import { ServiceAttributes, ServiceColors} from 'src/app/shared/models/enum-list';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { VariantConfigDialogComponent } from './variant-config-dialog/variant-config-dialog.component';
import { ResolveVariantConfigDialogComponent } from './resolve-variant-config-dialog/resolve-variant-config-dialog.component';
import { ResolveDeletedModelDialogComponent } from './resolve-deleted-model-dialog/resolve-deleted-model-dialog.component';
import { ViewDupModelDialogComponent } from './view-dup-model-dialog/view-dup-model-dialog.component'
import { RenameVariantComponent } from './variant-config-dialog/rename-variant/rename-variant.component';
import { NgStyle, NgIf, NgFor, NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

interface DuplicateModels {
  variant_name: Record<string, { model_name: string[] }>;
  all_duplicated_model_names: string[];
}



@Component({
    selector: 'app-pitch-dialog',
    templateUrl: './pitch-dialog.component.html',
    styleUrls: ['./pitch-dialog.component.scss'],
    imports: [MatDialogTitle, NgStyle, NgIf, MatButton, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, NgFor, MatOption, MatInput, MatIcon, NgClass, MatTooltip, MatProgressSpinner, MatDialogActions]
})

export class PitchDialog {
  plantName: string;
  teamID: number;
  teamName: string;
  versionID: number = 1;
  versionName: string = 'Initial';
  pitchConfigID: number;
  pitchID: string;
  pitchName: string;
  ergoScore: number;
  ergoComments:string = '';
  line: string;
  coverTeam: number;

  pitchType: string;
  subassemblyID: string;
  taktTime: number;
  
  typeOptions: string[];
  subassemblyIDOptions: string[];
  canDelete: boolean;

  pitchFormGroup: FormGroup;
  pitchFormType: string;
  totalwork: number;
  status: string;

  previousSelectedVariants: TeamVariant[] = [];
  disableVariantSelection: boolean = false;

  availableFlags: Flag[] = [];
  availableFlagIDs: string[] = [];
  selectedFlags: string[] = [];
  previousSelectedFlags: Flag[] = [];
  isBusy: boolean = false;
  unique: boolean = true;
  pitchStatuses: string[] = ['open', 'blocked', 'active', 'covered by another team'];
  pitchStatusChange :boolean = false;

  availablePitches: ServiceTie[];
  availablePitchIDs: string[];
  selectedServiceTies: number[];
  serviceAttribute: string = ''
  serviceColor: string = ''
  waterSpiders: string[]
  kitters: string[]
  repackers: string[]
  availablePitchIDs_WKR: string[];
  newPitchID: string = '';
  newServicePitchID: string = '';
  newSubassemblyPitchID: string = '';
  subassemblyexists: boolean;
  listofexistingsubassemblyID:string[] = [];
  totalWork: number;
  num_pitches: number;

  resetStatus: boolean = false;
  resetStatusValue: string = '';

  serviceType: boolean = false;
  subassemblySub!: Subscription;
  materials: string;

  teamType: string = 'Pitch'
  teamTypePlural: string = 'Pitches'
  teamTimeType: string = 'Takt Time'

  pitchCreateMessage: string;
  createMultiplePitches: boolean = false;
  evenOddOptions: string[];
  evenOdd: string = '';
  existing_pitches: number;

  availableTeams: LineTeam[] = [];
  coveredByAnotherTeam: boolean = false;

  variantList: TeamVariant[]=[];

  teamVariants: TeamVariant[] = [];
  deleteTeamVariants: TeamVariant[] = [];

  materialsVariants: TeamVariant[]=[]
  errorFlag: string = 'no error';
  dup_list: DuplicateModels = {
    variant_name: {},
    all_duplicated_model_names: []
  };



  constructor(
    public dialogRef: MatDialogRef<PitchDialog>,
    @Inject(MAT_DIALOG_DATA) public pitchData: PitchDialogData,
    private pitchFormBuilder: FormBuilder,
    private teamService: TeamService,
    private deleteDialog: MatDialog,
    private updateDialog: MatDialog,
    private variantDialog: MatDialog
  )
  { 
    console.log('pitchData: ', pitchData)
    this.existing_pitches = pitchData.pitchList.length

    pitchData.form_type  ? this.pitchFormType = pitchData.form_type : this.pitchFormType = 'Create New Pitch'
    pitchData.plant_name ? this.plantName = pitchData.plant_name : this.plantName = ''
    pitchData.team_id ? this.teamID = pitchData.team_id: this.teamID = 0
    pitchData.team_name ? this.teamName = pitchData.team_name: this.teamName = ''
    pitchData.version_id ? this.versionID = pitchData.version_id: this.teamID = 0
    pitchData.version_name ? this.versionName = pitchData.version_name: this.teamName = ''
    pitchData.materials ? this.materials = pitchData.materials: this.materials = 'no'
    pitchData.line ? this.line = pitchData.line: this.line = '';
    pitchData.cover_team ? this.coverTeam = pitchData.cover_team: this.coverTeam = 0;
    console.log('Cover Team: ', pitchData.cover_team, this.coverTeam)
    

    this.teamService.getTeamsByLine(this.plantName, this.line).subscribe((
      out=>{
        this.availableTeams = out.Body
        console.log('Available Teams: ', this.availableTeams)
      }
    ));
    

    this.teamService.getFlags().subscribe((
      out=>{
        this.availableFlags = out.Body
        this.availableFlagIDs = this.availableFlags.map(flag => flag.flag_id)
      }
    ))

    pitchData.service_ties ? this.availablePitches = pitchData.service_ties : this.availablePitches = []
    this.availablePitchIDs = this.pitchData.pitchList.filter(pitch=> pitch.type === 'pitch').map(pitch => pitch.pitch_id)

    this.waterSpiders = this.pitchData.pitchList.filter(pitch=> pitch.type === 'waterspider').map(w => w.pitch_id)
    this.kitters = this.pitchData.pitchList.filter(pitch=> pitch.type === 'kitter').map(k => k.pitch_id)
    this.repackers = this.pitchData.pitchList.filter(pitch=> pitch.type === 'repacker').map(r => r.pitch_id)
    
    this.availablePitchIDs_WKR = this.pitchData.pitchList.filter(pitch=> pitch.type === 'waterspider' || pitch.type === 'kitter' || pitch.type === 'repacker').map(w => w.pitch_id);
    this.setPrefillIDValues()

    pitchData.type ? this.pitchType = pitchData.type : this.pitchType = ''        
    pitchData.pitch_id ? this.pitchID = pitchData.pitch_id : this.pitchID = this.newPitchID
    pitchData.pitch_config_id ? this.pitchConfigID = pitchData.pitch_config_id : this.pitchConfigID = 0
    pitchData.subassembly_id ? this.subassemblyID = pitchData.subassembly_id : this.subassemblyID = ''
    pitchData.takt_time ? this.taktTime = pitchData.takt_time : this.taktTime = 0
    pitchData.pitchVariants ? this.teamVariants = pitchData.pitchVariants : [];
    pitchData.pitchVariants ? this.previousSelectedVariants= pitchData.pitchVariants :[];
    pitchData.flags ? this.selectedFlags = pitchData.flags.map(flag => flag.flag_id) : this.selectedFlags = []
    pitchData.flags ? this.previousSelectedFlags = pitchData.flags : this.previousSelectedFlags = []
    pitchData.can_delete ? this.canDelete = pitchData.can_delete : this.canDelete = false
    pitchData.totalwork ? this.totalwork = pitchData.totalwork : this.totalwork = 0
    pitchData.status ? this.status = pitchData.status : this.status = 'active'
    this.status == 'covered by another team' ? this.coveredByAnotherTeam = true : this.coveredByAnotherTeam = false
    pitchData.pitch_name ? this.pitchName = pitchData.pitch_name : this.pitchName = ''
    pitchData.ergo_score ? this.ergoScore = pitchData.ergo_score : this.ergoScore = -1
    pitchData.service_ties ? this.selectedServiceTies = pitchData.service_ties.map(pitch => pitch.pitch_config_id) : this.selectedServiceTies = []
    pitchData.service_attribute ? this.serviceAttribute = pitchData.service_attribute : this.serviceAttribute = ''
    pitchData.service_color ? this.serviceColor = pitchData.service_color : this.serviceColor = ''
    pitchData.tot_work ? this.totalWork = pitchData.tot_work : this.totalWork = 0
    pitchData.num_pitches ? this.num_pitches = pitchData.num_pitches: this.num_pitches = 0
    pitchData.error_flag? this.errorFlag = pitchData.error_flag : this.errorFlag = 'no error'

    if (this.errorFlag != 'no error'){
      this.pitchVariantError();
    }
    
    this.typeOptions = this.materials === 'yes' ? ['route'] : ['pitch', 'subassembly', 'waterspider', 'kitter', 'repacker'];
    this.subassemblyIDOptions = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']

    if (this.materials == 'yes') {
      console.log('here')
      this.teamType = 'Route';
      this.teamTypePlural = 'Routes';
      this.teamTimeType = 'Route Time';
      this.pitchType = 'route';
      this.setMaterialsVariants();
      this.disableVariantSelection = true;
    } else {
      this.teamType = 'Pitch';
      this.teamTypePlural = 'Pitches';
      this.teamTimeType = 'Takt Time';
      // Initialize pitchType to 'pitch' if no type is provided in the pitchData
      this.pitchType = pitchData.type ? pitchData.type : ''
    }

    this.pitchCreateMessage = 'Create Multiple ' + this.teamTypePlural
    this.evenOddOptions = ['Even ' + this.teamTypePlural, 'Odd ' + this.teamTypePlural, 'All ' + this.teamTypePlural]
    
    this.pitchFormGroup = this.pitchFormBuilder.group({
      form_pitchID: [(this.pitchID == null)? '': this.pitchID, [Validators.required, CustomValidators.lengthThree, CustomValidators.rightThreeNumber]],
      form_pitchType: [(this.pitchType == null)? 'pitch': this.pitchType, Validators.required],
      form_subassemblyID: [(this.subassemblyID == null)? '': this.subassemblyID],
      form_status: [(this.status == null)? 'open': this.status],
      form_pitchName: [(this.pitchName == null)? '' : this.pitchName],
      form_taktTime: [(this.taktTime == 0)? '' : this.taktTime, Validators.required],
      form_flags: [this.selectedFlags],
      form_service_ties: [this.selectedServiceTies],
      form_evenOdd: ['All ' + this.teamTypePlural, Validators.required],
      form_coverTeam: [(this.coverTeam == null)? '': this.coverTeam]
    })

    this.pitchFormGroup.valueChanges.subscribe((formValues) =>{
      this.pitchID = formValues.form_pitchID,
      this.pitchType = formValues.form_pitchType,
      this.taktTime = formValues.form_taktTime,
      this.selectedFlags = formValues.form_flags,
      this.pitchName = formValues.form_pitchName,
      this.status = formValues.form_status,
      this.selectedServiceTies = formValues.form_service_ties,
      this.evenOdd = formValues.form_evenOdd,
      this.coverTeam = formValues.form_coverTeam
    });

    this.pitchFormGroup.controls['form_pitchType'].valueChanges.subscribe((value) => {

      if (this.subassemblySub) {
        this.subassemblySub.unsubscribe();
      }

      if(value == "pitch"){
        this.pitchFormGroup.controls['form_pitchID'].setValue(this.newPitchID)
        this.pitchFormGroup.controls['form_subassemblyID'].setValue("")
        this.subassemblyID = "";
        this.serviceAttribute = ''
        this.serviceColor = ''
      }
      else if(value == "subassembly")
      {
        if ((this.pitchData.form_type == 'Create New Pitch') && !this.subassemblySub) {
        this.subassemblySub = this.pitchFormGroup.controls['form_pitchID'].valueChanges.subscribe((val)  => {
          this.pitchFormGroup.controls['form_subassemblyID'].setValue(this.getNextSubassemblyID(val))
          this.subassemblyID = this.getNextSubassemblyID(val)
          });
        }
        else {
          this.pitchFormGroup.controls['form_subassemblyID'].setValue("A");
          this.subassemblyID = "A";
        }
        this.pitchFormGroup.controls['form_pitchID'].setValue(this.newSubassemblyPitchID)
        this.serviceAttribute = ''
        this.serviceColor = ''
      }
      else {
        if (value == "waterspider"){
          this.pitchFormGroup.controls['form_pitchID'].setValue(this.newServicePitchID)
          this.serviceAttribute = ServiceAttributes.WaterSpider
          if (this.waterSpiders.length == 1)
            this.serviceColor = ServiceColors.DarkBlue
          else if (this.waterSpiders.length == 2)
            this.serviceColor = ServiceColors.DarkGreen
          else if (this.waterSpiders.length == 3)
            this.serviceColor = ServiceColors.Purple
          else
            this.serviceColor = ServiceColors.DarkRed
        
          } else if (value == "kitter"){
            this.pitchFormGroup.controls['form_pitchID'].setValue(this.newServicePitchID)
            this.serviceAttribute = ServiceAttributes.Kitter
            if (this.kitters.length == 1)
              this.serviceColor = ServiceColors.DarkBlue
            else if (this.kitters.length == 2)
              this.serviceColor = ServiceColors.DarkGreen
            else if (this.kitters.length == 3)
              this.serviceColor = ServiceColors.Purple
            else
              this.serviceColor = ServiceColors.DarkRed
        
          } else if (value == "repacker"){
            this.pitchFormGroup.controls['form_pitchID'].setValue(this.newServicePitchID)
            this.serviceAttribute = ServiceAttributes.Repacker
            if (this.repackers.length == 1)
              this.serviceColor = ServiceColors.DarkBlue
            else if (this.repackers.length == 2)
              this.serviceColor = ServiceColors.DarkGreen
            else if (this.repackers.length == 3)
              this.serviceColor = ServiceColors.Purple
            else
              this.serviceColor = ServiceColors.DarkRed
          }

        this.serviceType = true
      }
    });

    if ((this.pitchData.form_type == 'Edit Pitch') && (this.pitchData.type == 'pitch') && 
      (this.pitchData.pitchList.some(pitch => pitch.pitch_id === pitchData.pitch_id && pitch.subassembly_id != ""))){
      this.subassemblyexists = true
      this.listofexistingsubassemblyID = this.pitchData.pitchList.filter(item => item.pitch_id === this.pitchData.pitch_id).map(item => item.subassembly_id).filter(id => id !== "")
    }
    else {
      this.subassemblyexists = false
    }

    this.pitchFormGroup.controls['form_subassemblyID'].valueChanges.subscribe((value) => {
      this.subassemblyID = value;
    });

    this.pitchFormGroup.controls['form_status'].valueChanges.subscribe((value)=>{
      console.log('here')
    
      this.statusChange(value, this.status)
      
    })

    this.pitchFormGroup.controls['form_coverTeam'].valueChanges.subscribe((value) => {
      console.log(value)
      let teamIndex = this.availableTeams.findIndex(team => team.team_id === value);
      console.log(teamIndex)
      if (teamIndex != -1){
        console.log(this.availableTeams[teamIndex])
        this.pitchFormGroup.controls['form_pitchName'].setValue('Covered by ' + this.availableTeams[teamIndex].subline + ' Team: ' + this.availableTeams[teamIndex].team_name)
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close({ error_flag: this.errorFlag });
  }

  togglePitchCreateMode() {
    this.createMultiplePitches = !this.createMultiplePitches
    if(this.createMultiplePitches){
      this.pitchCreateMessage = "Create Single " + this.teamType
      
      this.pitchFormGroup.controls['form_taktTime'].setValue(this.pitchData.takt_time);
    } 
    else {
      this.pitchCreateMessage = "Create Multiple " + this.teamTypePlural
    }
  }

  generateResponse() {
    let pitchIDs: string[] = [];
    let pitch_id = this.pitchID.slice(0,this.pitchID.length - 3)
    let start_number = Number(this.pitchID.slice(this.pitchID.length - 3));
    let increment = 0
    if(this.evenOdd === "Even " + this.teamTypePlural){
      increment = 2
      if (start_number % 2 != 0){
        start_number += 1
      }
    }
    else if (this.evenOdd === "Odd " + this.teamTypePlural){
      increment = 2
      if (start_number % 2 == 0){
        start_number += 1
      }
    }
    else {
      increment = 1
    }
    for (let i = 0; i < this.num_pitches; i++) {
      let pitch_number = start_number + increment * i
      let formattedPitchNum = pitch_number.toString().padStart(3,'0')
      pitchIDs.push(`${pitch_id}${formattedPitchNum}`)
    }
    return pitchIDs
  }

  createPitch(): void {
    let variantIDs: number[] = this.teamVariants.map(variant=>variant.variant_id);
    console.log('Create Pitch:', this.teamVariants)
    let variantStatus: any[] = this.teamVariants.map((variant) =>({
        "variant_id": variant.variant_id, 
        "variant_status": variant.variant_status, 
        "variant_msg": variant.variant_msg
    }));
    
    console.log(variantIDs)
    let flags: string[] = this.selectedFlags
    this.isBusy = true
    this.unique = this.isPitchUniqueCreate()

    if (this.pitchFormGroup.status == 'VALID' && this.unique){
      if(this.createMultiplePitches){
        let pitchIDs = this.generateResponse()
        let pitchUpdate:Observable<any>[] = [];
        let pitchFlagUpdate:Observable<any>[] = [];
        pitchIDs.forEach(
          (pitchID) => {
            pitchUpdate.push(this.teamService.createPitch(this.plantName,this.teamID,this.versionID,pitchID.trim(),this.pitchType,'',this.pitchData.takt_time,'active', variantIDs, '', '', '', undefined, this.materials, variantStatus))
          } 
        )
        
        if (pitchUpdate.length > 0) {
          forkJoin(pitchUpdate).subscribe(
            result => {
              if(result.length > 0 && flags.length > 0){
                result.forEach(
                  (pitch) => {
                    pitchFlagUpdate.push(this.teamService.createPitchFlag(pitch.Body.pitch_config_id, flags, this.plantName, this.teamID, this.versionID, this.pitchID))
                  }
                )
                forkJoin(pitchFlagUpdate).subscribe(
                  result => {
                    const pitchFormData = {
                      pitch_id: this.pitchID,
                      type: this.pitchType
                    }
                    this.isBusy = false  
                    this.dialogRef.close(pitchFormData)
                  }
                )
              }
              else {
                const pitchFormData = {
                  pitch_id: this.pitchID,
                  type: this.pitchType
                }
                this.isBusy = false 
                this.dialogRef.close(pitchFormData)
              }
            }
          )
        }
      }
      else if(!this.createMultiplePitches) {
        this.teamService.createPitch(this.plantName,this.teamID,this.versionID,this.pitchID.trim(),this.pitchType,this.subassemblyID,this.taktTime,this.status,variantIDs, 
          this.pitchName, this.serviceAttribute, this.serviceColor, this.coverTeam, this.materials, variantStatus).subscribe
        (out => {
          console.log('Pitch Call Return: ', out)
          let pitchConfigID = out.Body.pitch_config_id
          this.pitchConfigID = pitchConfigID;

          const pitchFormData = {
            pitch_id: this.pitchID,
            type: this.pitchType
          }

          if (flags.length > 0){
            this.teamService.createPitchFlag(pitchConfigID, flags, this.plantName, this.teamID, this.versionID, this.pitchID).subscribe(out => {
              this.isBusy = false
              this.dialogRef.close(pitchFormData)
            })
          } else {
            this.isBusy = false
            this.dialogRef.close(pitchFormData)
          }
        })
      }
      else if(!this.unique){
        this.isBusy = false
      }
      else {
        console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
      }
    }
  }
  
  updatePitch(status?: string){
    let closeDialog: boolean = status && status == 'open'? false: true;
    let variantIDs: number[] = this.teamVariants.map(variant=>variant.variant_id);
    let variantStatus: any[] = this.teamVariants.map((variant) =>({
        "variant_id": variant.variant_id, 
        "variant_status": variant.variant_status, 
        "variant_msg": variant.variant_msg
    }));

    
    let flags: string[] = this.getNewFlags()
    this.isBusy = true
    this.unique = this.isPitchUniqueUpdate()

    console.log('Flags:', flags)
    
    if(this.pitchFormGroup.status == 'VALID' && this.unique && this.teamVariants.length > 0){
      this.unselectedFlags()
      this.teamService.updatePitch(this.plantName,this.teamID,this.versionID,this.pitchConfigID,this.pitchID.trim(),
        this.pitchType,this.subassemblyID,this.taktTime,this.status,variantIDs, this.pitchName, this.ergoScore,
        this.ergoComments, this.serviceAttribute, this.serviceColor, this.coverTeam, this.materials, variantStatus).subscribe
      (out => {
        let pitchConfigID = out.Body.pitch_config_id
        let pitchUpdate:Observable<any>[] = [];

        if (flags.length >0){
          pitchUpdate.push(this.teamService.createPitchFlag(pitchConfigID, flags, this.plantName, this.teamID, this.versionID, this.pitchID))
        }

        
        if (this.deleteTeamVariants.length > 0){
          this.deleteTeamVariants.forEach(variant =>{
            pitchUpdate.push(this.teamService.deletePitchVariant(this.pitchConfigID,variant.variant_id,this.plantName,this.teamID,this.versionID,this.pitchID,
              variant.variant_name))
          })
        }

        if (pitchUpdate.length > 0){
          forkJoin(pitchUpdate).subscribe(out=>{
            this.isBusy = false
            if (closeDialog){
              this.dialogRef.close({ error_flag: this.errorFlag})
            }
          });
        } else {
          this.isBusy = false;
          if (closeDialog){
            this.dialogRef.close();
          }
        }
      });
    } else if (!this.unique || this.teamVariants.length >= 0) {
      this.isBusy = false  
    } else {
      console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
    }
  }

  deletePitch(){
    this.isBusy = true
    if(this.pitchFormGroup.status == 'VALID'){ 
      const dialogRef = this.deleteDialog.open(DeleteDialogComponent, {
        width: '500px',
        data: 
        {
          team_name: this.teamName,
          version_name: this.versionName,
          pitch_config_id: this.pitchConfigID,
          pitch_id: this.pitchID,
          pitchVariants: this.teamVariants,
          totalwork: this.totalwork,
          can_delete: this.canDelete,
          form_type: 'deletePitch'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined && result.action == 'delete'){
            this.teamService.deletePitch(this.pitchConfigID,this.plantName,this.teamID,this.versionID,this.pitchID).subscribe(out=> {
              this.isBusy = false
              this.dialogRef.close()
            })
        } else {
          this.isBusy = false
          this.dialogRef.close()
        }
      })
    } else {
      console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
    }
  }

  deleteVariant(){
    let variants: TeamVariant[] = this.previousSelectedVariants;
    this.isBusy = true
    if(this.pitchFormGroup.status == 'VALID'){ 
      let variantsToDelete: TeamVariant[] = this.deleteTeamVariants
      let totalVariantwork: number = 0
      let index: number
      variantsToDelete.forEach(variant =>{
        index = this.previousSelectedVariants.findIndex(id => id.variant_id === variant.variant_id)
        if (index !== -1) {
          const selectedVariant = this.previousSelectedVariants[index];
          if (selectedVariant) {
            totalVariantwork += selectedVariant.total_work ?? 0;
          }
        }
      })
      const dialogRef = this.deleteDialog.open(DeleteDialogComponent, {
        width: '500px',
        data: 
        {
          plant_name: this.plantName,
          team_name: this.teamName,
          version_name: this.versionName,
          pitch_config_id: this.pitchConfigID,
          pitch_id: this.pitchID,
          pitchVariants: this.previousSelectedVariants,
          uncheckedvariants: variants.map(variant => variant.variant_name),
          uncheckedvariantswork : totalVariantwork,
          totalwork:this.totalwork,
          can_delete: this.canDelete,
          form_type: 'deleteVariant'
        }
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined && result.action == 'delete'){
            variantsToDelete.forEach(variant => {
              this.teamService.deletePitchVariant(this.pitchConfigID,variant.variant_id,this.plantName,this.teamID,this.versionID,this.pitchID,variant.variant_name).subscribe(out=> {
                this.isBusy = false
                this.dialogRef.close()
                })
              })
          }
        else {
          this.isBusy = false
          this.dialogRef.close()
        }
      })
    } else {
      console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
    }
  }

  getNewFlags() : string[] {
    let flags: string[] = []
    this.selectedFlags.forEach (selected => {
      if (this.previousSelectedFlags.find(id => id.flag_id === selected) == undefined)
        flags.push(selected)
    })
    return flags
  }

  unselectedFlags(){ 
    this.previousSelectedFlags.forEach(prv_selected =>{
      if (this.selectedFlags.find(id => id === prv_selected.flag_id) == undefined)
      {
        this.teamService.deletePitchFlag(this.pitchConfigID, prv_selected.flag_id, this.plantName, this.teamID, this.versionID, this.pitchID).subscribe(out=>{})
      }
    })
  }

  normalizeString(s: string): string {
    return s.replace(/\s+/g, '').toLowerCase()
  }

  isPitchUniqueCreate(): boolean {
    var filteredList = this.pitchData.pitchList
    var unique: boolean = true

    filteredList.forEach(pitch => {
      if (this.normalizeString(pitch.pitch_id) == this.normalizeString(this.pitchID)){
        if (this.pitchType == 'subassembly' && pitch.type == 'subassembly'){
          if (this.normalizeString(pitch.subassembly_id) == this.normalizeString(this.subassemblyID)){
            unique = false
          }
        } else if (this.pitchType == 'pitch') {
          unique = false
        }
      }
    })
    
    return unique
  }

  isPitchUniqueUpdate(): boolean {
    var filteredList = this.pitchData.pitchList
    var unique: boolean = true
    let variantIndex: number
    filteredList.forEach(pitch => {
      if (this.normalizeString(pitch.pitch_id) == this.normalizeString(this.pitchID) && pitch.pitch_config_id != this.pitchConfigID){
        if (this.pitchType == 'subassembly' && pitch.type == 'subassembly'){
          if (this.normalizeString(pitch.subassembly_id) == this.normalizeString(this.subassemblyID)){
            console.log('subassembly uniqueness')
            unique = false
          }
        } else if (this.pitchType == 'pitch' && pitch.type == 'pitch') {
          console.log('pitch uniqueness')
          unique = false
        }
      }
    })
    
    return unique
  }

  getPrefillPitchID(type:string): string {
    let prefillPitchID: string = '';    
    let pitchIDList: string[] = [];
    let lastPitchID: string = '';
    let lastPitchIDNum: number = 0;
    console.log('Type: ', type)
    if (type == 'service')
      pitchIDList = this.availablePitchIDs_WKR     
    else
      pitchIDList = this.availablePitchIDs  
    console.log('Pitches:', pitchIDList)  
    if ((pitchIDList.length > 0) && (type != 'subassembly')) {
      console.log('Pitch ID List:', pitchIDList)
      lastPitchID = pitchIDList[pitchIDList.length - 1]
      lastPitchIDNum = Number(lastPitchID.slice(lastPitchID.length - 3))
      lastPitchIDNum = lastPitchIDNum + 1    
      prefillPitchID = lastPitchID.slice(0, - 3) + lastPitchIDNum.toString().padStart(3, "0")
    } else if ((pitchIDList.length > 0) && (type == 'subassembly')){
      prefillPitchID = pitchIDList[pitchIDList.length - 1]
    } else if (type == 'pitch' && this.availablePitchIDs_WKR.length > 0) {      
      prefillPitchID = this.availablePitchIDs_WKR[this.availablePitchIDs_WKR.length - 1].slice(0, -3) + '001'
    } else if (type =='service' && this.availablePitchIDs.length > 0) {
      prefillPitchID = this.availablePitchIDs[this.availablePitchIDs.length - 1].slice(0, - 3) + '900'
    }
    return prefillPitchID;
  }

  setPrefillIDValues(){

    if (this.pitchData.form_type == 'Create New Pitch')
    {
      this.newPitchID = this.getPrefillPitchID('pitch')
      this.newSubassemblyPitchID = this.getPrefillPitchID('subassembly')
      this.newServicePitchID = this.getPrefillPitchID('service')
    } else {
      if (this.pitchData.type == 'waterspider' || this.pitchData.type == 'repacker' || this.pitchData.type == 'kitter'){
        this.newPitchID = this.getPrefillPitchID('pitch')
        this.newSubassemblyPitchID = ''
        this.newServicePitchID = this.pitchData.pitch_id
      } else if (this.pitchData.type == 'subassembly') {
        this.newPitchID = this.getPrefillPitchID('pitch')
        this.newSubassemblyPitchID = this.pitchData.pitch_id
        this.newServicePitchID = this.getPrefillPitchID('service')
      } else {
        this.newPitchID = this.pitchData.pitch_id
        this.newSubassemblyPitchID = this.pitchData.pitch_id
        this.newServicePitchID = this.getPrefillPitchID('service')
      }
    }
    console.log('Pitch ID:', this.newPitchID)
    console.log('Service ID:', this.newServicePitchID)
    console.log('Subassembly ID:', this.newSubassemblyPitchID)
  }
  
  getNextSubassemblyID(currentSubassemblyPitchID: string): string {
    let selectedPitchSubAssemblyIDs:string[] =  this.pitchData.pitchList.filter(pitch=> pitch.pitch_id === currentSubassemblyPitchID).map(pitch => pitch.subassembly_id)
    const index = this.subassemblyIDOptions.indexOf(selectedPitchSubAssemblyIDs.length > 0 ? selectedPitchSubAssemblyIDs.slice(-1)[0] : '');
    if (index !== -1 && index < this.subassemblyIDOptions.length - 1) {
        return this.subassemblyIDOptions[index + 1];
    }
    return this.subassemblyIDOptions[0]; // Return the first element if current subassembly is not found or it's the last one
  }

  statusChange (value: string, status: string) {
    console.log(value)
    console.log('THIS: ', this.status)
    this.coveredByAnotherTeam = false;

    if (this.resetStatus){
      this.pitchFormGroup.controls['form_status'].setValue(this.resetStatusValue)
      this.resetStatus = false;
      this.resetStatusValue = '';
    }


    if (this.status == 'active' && (value == 'open' || value == 'blocked' || value == 'covered by another team') && this.totalWork > 0)
    {
      this.isBusy = true
      if(this.pitchFormGroup.status == 'VALID'){ 
        const dialogRef = this.updateDialog.open(PitchUpdateDialogComponent, {
          width: '500px',
          data: 
          {
            pitch_id: this.pitchID,
            pitch_name: this.pitchName,
            subassembly_id: this.subassemblyID,
            variant_count: this.previousSelectedVariants.length 
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('After close! ', result)
          if (result != undefined && result.confirmation){
            console.log('CONFIRMED')
            this.isBusy = false
          } else {
            this.onNoClick()
          }
        })
      } else {
        console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
      } 
    }

    if (value == 'covered by another team'){
      this.coveredByAnotherTeam = true;
    }
  }

  defineTeamVariant(){
    const dialogRef = this.variantDialog.open(VariantConfigDialogComponent,{
      width: '500px',
      data: { team_id: this.teamID, team_name: this.teamName, version_id: this.versionID, variant_list: this.teamVariants, 
              plant_name: this.plantName, pitch_config_id: this.pitchConfigID}
    });

    dialogRef.afterClosed().subscribe(result =>{
      // add team variant to variant list
      console.log(result)
      if (result != undefined){
        if ( result.variant ){
          console.log(result.variant, !this.teamVariants.some(variant=>variant.variant_id===result.variant.variant_id))
          if (!this.teamVariants.some(variant=>variant.variant_id===result.variant.variant_id)){
            this.teamVariants.push(result.variant)
            this.deleteTeamVariants = this.deleteTeamVariants.filter(variant=>variant.variant_id !== result.variant.variant_id)
          
            this.pitchVariantError();
          }
          console.log(this.teamVariants)
        }
        if ( result.removeVariant && result.removeVariant.variant_id != 0 ){
          this.teamVariants = this.teamVariants.filter(variant=>variant.variant_id !== result.removeVariant.variant_id)
          this.deleteTeamVariants.push(result.removeVariant);
        }
        this.pitchVariantError();
        if ( result.update_pitch ){
          this.updatePitch('open');
        }
      }
    })
    console.log(this.teamVariants)
  }

  removeVariant(variant: any){
    let canDelete:boolean = true;

    let totalVariantWork: number = variant.total_work;
    if (totalVariantWork > 0){
      const dialogRef = this.deleteDialog.open(DeleteDialogComponent, {
      width: '500px',
        data: 
          {
            plant_name: this.plantName,
            team_name: this.teamName,
            version_name: this.versionName,
            pitch_config_id: this.pitchConfigID,
            pitch_id: this.pitchID,
            pitchVariants: this.previousSelectedVariants,
            uncheckedvariants: variant.variant_name,
            uncheckedvariantswork : totalVariantWork,
            totalwork:this.totalwork,
            can_delete: this.canDelete,
            form_type: 'deleteVariant'
          }
      });
    
      dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result != undefined && result.action == 'delete'){
          this.teamVariants = this.teamVariants.filter(tv=> tv.variant_id !== variant.variant_id)
          this.deleteTeamVariants.push(variant);
          this.pitchVariantError();    
        } 
      });
    } else {
      this.teamVariants = this.teamVariants.filter(tv=> tv.variant_id !== variant.variant_id)
      this.deleteTeamVariants.push(variant);
      this.pitchVariantError();
    }
    
    
  }

  setMaterialsVariants(){
    console.log(!this.teamVariants.some(variant=>variant.variant_name === 'High'))
    console.log(!this.teamVariants.some(variant=>variant.variant_name ==='Low'))

    this.teamService.getTeamVariant(this.teamID).subscribe(out=>{
        console.log('Team Variants', out)
        if (!this.teamVariants.some(variant => variant.variant_name === 'High')){
          let highIndex = out.Body.findIndex(value =>  value.variant_name === 'High')
          if (highIndex != -1){
            this.teamVariants.push(out.Body[highIndex])
          }
        }

        if (!this.teamVariants.some(variant => variant.variant_name === 'Low')){
          let lowIndex = out.Body.findIndex(value =>  value.variant_name === 'Low')
          if (lowIndex != -1){
            this.teamVariants.push(out.Body[lowIndex])
          }
        }
      })

  }

  resolveVariantError(){
    if (this.errorFlag == "Base Variant Error"){
      this.resolveBaseVariant();
    } else if (this.errorFlag == "Deleted Model Variant") {
      this.teamVariants.forEach(variant => {
        if (variant.model_variants && variant.model_variants.some(model => model.deleted_flag == 1)){
          this.resolveDeletedVariant(variant);
        }
      })
    } else if (this.errorFlag === "Duplicated Model Variant") {
      this.viewDupModelVariant();
    }
  }

  pitchVariantError(){
    console.log('TeamVariants', this.teamVariants)
    if (this.teamVariants.some(variant => variant.base_variant_id == 1) && this.teamVariants.filter(variant => variant.base_variant_id == 0).length > 0){
      this.errorFlag = "Base Variant Error";
    } else {
      this.errorFlag = "no error";
    }
    if (this.errorFlag == "no error"){
      this.dup_list = this.findDuplicateModelsInVariants(this.teamVariants)
      if(Object.keys(this.dup_list.variant_name).length !== 0){
        this.errorFlag = "Duplicated Model Variant"
      }
      this.teamVariants.forEach(variant=> {
        if (variant.model_variants && variant.model_variants.some(model => model.deleted_flag == 1)){
          this.errorFlag = "Deleted Model Variant"
        }
      });
    }
  }

  variantInError(variant:TeamVariant):boolean{
    let inError:boolean = false;
    if (this.errorFlag == 'Base Variant Error'){
      if (variant.base_variant_id == 1){
        inError = true;
      }
    } else if (this.errorFlag == "Deleted Model Variant"){
      if (variant.model_variants?.some(model => model.deleted_flag == 1)){
        inError = true;
      }
    } else if (this.errorFlag === "Duplicated Model Variant"){
      if(this.dup_list['variant_name'][variant.variant_name]){
        inError = true;
      }
    }
    return inError;
  }

  resolveBaseVariant(){
    const dialogRef = this.variantDialog.open(ResolveVariantConfigDialogComponent, {
      width: '500px',
        data: 
        {
          plant_name: this.plantName,
          team_id: this.teamID,
          version_id: this.versionID,
          pitch_config_id: this.pitchConfigID,
          variant_list: this.teamVariants
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined){
        console.log(result)
        if (result.removeBase != 0){
          this.teamVariants = this.teamVariants.filter(tv=> tv.variant_id !== result.removeBase.variant_id)
          this.deleteTeamVariants.push(result.removeBase);
          if (result.variant && !this.teamVariants.some(variant=>variant.variant_id===result.variant.variant_id)){
            this.teamVariants.push(result.variant)
          }
        }
        this.pitchVariantError();
        this.updatePitch('open');
      }
    });
  }

  resolveDeletedVariant(variant: TeamVariant){
    console.log("Resolve Deleted Variant", variant)

    const dialogRef = this.variantDialog.open(ResolveDeletedModelDialogComponent, {
      width: '500px',
        data: 
        {
          plant_name: this.plantName,
          team_id: this.teamID,
          version_id: this.versionID,
          pitch_config_id: this.pitchConfigID,
          old_variant: variant,
          variant_list: this.teamVariants
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined){
        console.log(result)
        if (result.removeOldVariant){
          this.teamVariants = this.teamVariants.filter(tv=> tv.variant_id !== result.removeOldVariant.variant_id)
          this.deleteTeamVariants.push(result.removeOldVariant);
          if (result.variant && !this.teamVariants.some(variant=>variant.variant_id===result.variant.variant_id)){
            this.teamVariants.push(result.variant)
          }
        }
        this.pitchVariantError();
        this.updatePitch('open');
      }
    });
  }

  viewDupModelVariant(){
    const dialogRef = this.variantDialog.open(ViewDupModelDialogComponent, {
      width: '700px',
        data: 
        {
          dup_list: this.dup_list,
          pitch_id: this.pitchID
        }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.pitchVariantError();
    })
  }

  findDuplicateModelsInVariants(variantDetails: any[]): DuplicateModels {
    const modelMap: Record<string, { variant_name: string }[]> = {};

    variantDetails
      .filter(v => v.base_variant_id !== 1)
      .forEach(variant => {
        variant.model_variants.forEach((model: any) => {
          const name = model.model_name;

          if (!modelMap[name]) {
            modelMap[name] = [];
          }

          modelMap[name].push({
            variant_name: variant.variant_name
          });
        });
      });

    const duplicatedModels = Object.entries(modelMap)
      .filter(([_, occurrences]) => occurrences.length > 1);

    if (duplicatedModels.length === 0) {
      return {
        variant_name: {},
        all_duplicated_model_names: []
      };
    }

    const variantObj: Record<string, { model_name: string[] }> = {};
    const allDuplicatedNames: string[] = [];

    duplicatedModels.forEach(([modelName, occurrences]) => {
      allDuplicatedNames.push(modelName);

      occurrences.forEach(o => {
        if (!variantObj[o.variant_name]) {
          variantObj[o.variant_name] = { model_name: [] };
        }

        variantObj[o.variant_name].model_name.push(modelName);
      });
    });

    return {
      variant_name: variantObj,
      all_duplicated_model_names: allDuplicatedNames
    };
  }
  
  editVariant(inVariant: TeamVariant){
    const dialogRef = this.variantDialog.open(RenameVariantComponent,{
      width: '500px',
      data: { team_id: this.teamID, version_id: this.versionID, team_name: this.teamName, variant_id: inVariant.variant_id, variant_name: inVariant.variant_name,
         plant_name: this.plantName, model_variants: inVariant.model_variants, variant_status: inVariant.variant_status, variant_msg: inVariant.variant_msg  }
    });

    dialogRef.afterClosed().subscribe(result =>{
      if (result != undefined){
        let index = this.teamVariants.findIndex(variant => variant.variant_id === inVariant.variant_id)
        if (index != -1){
          this.teamVariants[index].variant_name = result.variant['variant_name'];
          this.teamVariants[index].variant_msg = result.variant['variant_msg'];
          this.teamVariants[index].variant_status = result.variant['variant_status'];
        }
      }
    })
  }  
}



export class CustomValidators {
  static lengthThree: ValidatorFn = (control: AbstractControl) => {
    var isValid: Boolean = false;
    var pitchIDStr: string = control.value;
    
    if(pitchIDStr.length < 3){
      console.log("String less than 3 characters")
      isValid = false;
    }else{
      isValid = true;
    }

    return isValid ? null : { lengthThree: true };
  }

  static rightThreeNumber: ValidatorFn = (control: AbstractControl) => {
    var isValid: Boolean = false;
    var pitchIDStr: string = control.value;
    var pitchID_lastchars:string = pitchIDStr.slice(pitchIDStr.length - 3);
    var isNotNumber: Boolean = false;
        
    for (var i = 0; i < pitchID_lastchars.length; i++) {

      if(!Number.isInteger(Number(pitchID_lastchars[i])) && isNotNumber == false){
        isNotNumber = true;
        break;        
      }
    }

    if (isNotNumber == true){
      console.log("Right three are not a number");
    }
    else {
      isValid = true;
    }

    return isValid ? null : { rightThreeNumber: true };
  }

}

export interface PitchDialogData {
  plant_name: string;
  team_id: number;
  team_name: string;
  version_id: number;
  version_name: string;
  pitch_config_id: number;
  pitch_id: string;
  type: string;
  subassembly_id: string;
  takt_time: number;
  pitchVariants: TeamVariant[];
  flags: Flag[];
  can_delete: boolean;
  form_type: string;
  totalwork: number;
  status: string;
  pitch_name: string;
  pitchList: PitchList[];
  ergo_score: number;
  service_ties: ServiceTie[];
  service_attribute: string;
  service_color: string;
  tot_work?: number;
  materials?: string;
  num_pitches?: number;
  line?: string;
  cover_team?: number;
  error_flag?: string;
  dup_list?: object;
}
